import { TaskListItem } from '@euler/model/TaskListItem';
import { memo } from 'react';
import { Refreshing } from '../../functions/useRefreshing';
import { BoardTable } from '../board-table';
import { TaskRow } from './TaskRow';
import { kTaskColumns } from './columns';

/** The open tasks, newest first. */
export const TaskTable = memo(
  ({ tasks, now }: { tasks: Refreshing<TaskListItem[]>; now: Date }) => (
    <BoardTable
      rows={tasks}
      columns={kTaskColumns}
      renderRow={task => <TaskRow key={task.id} task={task} now={now} />}
      emptyText="暂无未完工的工单"
      failedText="暂时无法获取工单，稍后自动重试"
      countText={items => `共 ${items.length} 辆在店`}
    />
  ),
);
